export default __webpack_public_path__ + "static/media/trr-drink-none.660bb6c7.png";